import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deviceApi } from '../../services/api';
import { deviceKeys } from '../queries/useDevices';

export function useCreateDevice() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) => deviceApi.createDevice(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: deviceKeys.all });
    },
  });
}

export function useUpdateDevice() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ deviceId, data }: { deviceId: string; data: any }) =>
      deviceApi.updateDevice(deviceId, data),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: deviceKeys.detail(variables.deviceId) });
      queryClient.invalidateQueries({ queryKey: deviceKeys.all });
    },
  });
}

export function useDeleteDevice() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (deviceId: string) => deviceApi.deleteDevice(deviceId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: deviceKeys.all });
    },
  });
}

export function useSendDeviceCommand() {
  return useMutation({
    mutationFn: ({
      deviceId,
      command,
      params,
    }: {
      deviceId: string;
      command: string;
      params?: Record<string, any>;
    }) => deviceApi.sendDeviceCommand(deviceId, command, params),
  });
}
